<template>
  <SettingsPage />
</template>

<script setup lang="ts">
import SettingsPage from "shared-ui/pages/SettingsPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    layout: "AppLayout",
  },
});
</script>
